module.exports = __webpack_public_path__ + "img/product-shansuan-ykyl-01.ac3d6ce8.png";